<template>
<div class="jzbWrap">
  <el-tabs v-model="activeTab"  @tab-click="handleClick">
      <el-tab-pane label="对私交易明细" name="person" v-if="jzb_attribute === 'private' || jzb_attribute === 'private-public'">
        <trans-detail v-if="person"  :type="2"></trans-detail>
      </el-tab-pane>
      <el-tab-pane label="对公交易明细" name="business" v-if="jzb_attribute === 'public' || jzb_attribute === 'private-public'">
        <trans-detail v-if="business" :type="1"></trans-detail>
      </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import TransDetail from './TransDetail'
export default {
  components: {TransDetail},
  data () {
    return {
      jzb_attribute: '',
      activeTab: 'person',
      business: false,
      person: true,
    }
  },
  created(){
    // 获取见证宝账号属性 对公 public 还是 对私 private private-public 两个同时存在
    const value = localStorage.getItem('jzb_attribute');
    this.jzb_attribute = value;
    this.activeTab = value === 'public' ? 'business' : 'person';
    this.business = value === 'public' ? true : false;
    this.person = value === 'private' || value === 'private-public' ? true : false;
  },
  methods: {
    handleClick (tab) {
      if (tab.name === 'business') {
        this.business = true
      }
      if (tab.name === 'person') {
        this.person = true
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/user/trans-detail-tab.vue